import {
  login,
  loginSuccess,
  loginFailure,
  validateTokenResponse,
  setPasswordSuccess,
  validateEstimateResponse,
} from "./authenticationSlice";
import { postRequest } from "app/axiosClient";
import { message } from "antd";
import {
  showLoader,
  hideLoader,
} from "CommonComponents/GlobalSpinner/GlobalSpinnerSlice";
import {
  forgotPasswordSuccess,
  forgotPasswordFailure,
} from "./authenticationSlice";
import OpenNotificationWithIcon from "CommonComponents/ResultNotification/Notification";
import StatusEnum from "features/Enums/StatusEnum";

export const LoginAPI = (values) => (dispatch) => {
  try {
    dispatch(showLoader());
    postRequest(`api/Login`, values)
      .then((res) => {
        if (res?.data?.errorResponse) {
          message.error(res?.data?.errorResponse?.errorMessage);
        } else {
          dispatch(loginSuccess(res?.data));
          message.success("Connexion réussie");
        }
        dispatch(hideLoader());
      })
      .catch((error) => {
        dispatch(hideLoader());
        const selectedLanguage = localStorage.getItem("selectedlanguage");
        const isFrench = selectedLanguage === "fr-FR";

        const invalidCredsMsg = isFrench
          ? "Veuillez saisir un nom d'utilisateur ou un mot de passe valide"
          : "Please enter a valid username or password";

        if (error?.response?.status === 400) {
          message.error(invalidCredsMsg);
        } else {
          message.error(invalidCredsMsg);
        }
      });
  } catch (e) {
    message.error("La connexion a échoué");
    dispatch(hideLoader());
  }
};

export const forgotPasswordAPI = (email) => (dispatch) => {
  try {
    dispatch(showLoader());
    postRequest(`api/Accounts/SendResetPasswordLink`, email)
      .then((res) => {
        dispatch(forgotPasswordSuccess(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
        dispatch(
          forgotPasswordFailure(
            "L'adresse e-mail saisie n'est associée à aucun utilisateur enregistré. Veuillez la vérifier et réessayer. Si le problème persiste, veuillez contacter l'assistance."
          )
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    dispatch(
      message.error(
        "error",
        "Erreur",
        "Oups! Un problème est survenu et nous n'avons pas pu envoyer le lien de réinitialisation du mot de passe. Veuillez réessayer ou contacter l'assistance si le problème persiste.."
      )
    );
  }
};

export const validatePasswordAPI = (token) => (dispatch) => {
  try {
    dispatch(showLoader());
    postRequest(`api/Accounts/ValidatePasswordResetRequest?token=${token}`)
      .then((res) => {
        dispatch(validateTokenResponse(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
        message.error(
          "error",
          "Erreur",
          "Impossible de valider la demande de mot de passe. Veuillez réessayer."
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    message.error(
      "error",
      "Erreur",
      "Impossible de valider la demande de mot de passe. Veuillez réessayer."
    );
  }
};

export const setPasswordAPI = (object) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Accounts/SetPassword`, object)
      .then((res) => {
        dispatch(setPasswordSuccess(res?.data));
        dispatch(hideLoader());
        return res?.data;
      })
      .catch((e) => {
        dispatch(hideLoader());
        message.error(
          "Oups! Une erreur s'est produite lors de la définition du nouveau mot de passe. Veuillez réessayer ou contacter l'assistance si le problème persiste."
        );
        return false;
      });
  } catch (e) {
    dispatch(hideLoader());
    message.error(
      "Oups! Une erreur s'est produite lors de la définition du nouveau mot de passe. Veuillez réessayer ou contacter l'assistance si le problème persiste."
    );
    return false;
  }
};
export const validateEstimateAPI = (token) => (dispatch) => {
  try {
    dispatch(showLoader());
    postRequest(`api/Client/ValidateEstimateRequest?token=${token}`)
      .then((res) => {
        dispatch(validateEstimateResponse(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
        message.error(
          "Error",
          "Impossible de valider la demande de devis. Veuillez réessayer."
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    message.error(
      "Error",
      "Impossible de valider la demande de devis. Veuillez réessayer."
    );
  }
};

export const estimateStatusChangeAPI = (payload, newStatusId) => (dispatch) => {
  try {
    dispatch(showLoader());
    postRequest(`api/Client/UpdateEstimateStatus`, payload)
      .then((res) => {
        dispatch(hideLoader());
        if (StatusEnum?.Accepted?.id === newStatusId) {
          OpenNotificationWithIcon(
            "success",
            "Common.Success",
            "",
            "Authenticate.Notification.Workordersuccessfullycreated"
          );
        }
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "Authenticate.Notification.Unabletoprocesstherequest"
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Authenticate.Notification.Unabletoprocesstherequest"
    );
  }
};
